import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// components
import { LTFilterButtonComponent } from './components/lt-filter-button/lt-filter-button.component';
import { LTFilterComponent } from './components/lt-filter/lt-filter.component';
import { LTFilterRowComponent } from './components/lt-filter-row/lt-filter-row.component';
import { LTFilterDialogComponent } from './components/lt-filter-dialog/lt-filter-dialog.component';

// service
import { LTFilterService } from './services/lt-filter.service';

@NgModule({
  imports: [
    CommonModule,
    LTFilterButtonComponent,
    LTFilterDialogComponent,
    LTFilterComponent,
    LTFilterRowComponent,
  ],
  exports: [
    LTFilterButtonComponent,
    LTFilterDialogComponent,
    LTFilterComponent,
    LTFilterRowComponent,
  ],
  providers: [
    // Provide the service at module level (optional, since it's providedIn: 'root')
    LTFilterService,
  ],
})
export class LTFilterModule { }